import { render, staticRenderFns } from "./light_point_list_Case.vue?vue&type=template&id=8d9bfb88&scoped=true"
import script from "./light_point_list_Case.vue?vue&type=script&lang=js"
export * from "./light_point_list_Case.vue?vue&type=script&lang=js"
import style0 from "./light_point_list_Case.vue?vue&type=style&index=0&id=8d9bfb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9bfb88",
  null
  
)

export default component.exports